import { normalize } from 'normalizr';
import { call, put, takeLatest } from 'redux-saga/effects';

import api from 'helpers/api';

import {
  FETCH_NEXT_BOOKING_REQUEST,
  fetchNextBookingSuccess,
  fetchNextBookingFailure
} from 'store/bookings/actions';

import * as schemas from '../../schemas';

function* fetchNextBookingApi() {
  const booking = yield api.backend
    .get('bookings/1')
    .then(response => response.data.booking);

  return booking;
}

function* fetchNextBooking() {
  try {
    const booking = yield call(fetchNextBookingApi);
    const response = normalize(booking, schemas.booking);

    yield put(fetchNextBookingSuccess(response));
  } catch (err) {
    yield put(fetchNextBookingFailure(err));
  }
}

export default function* bookingsSaga() {
  yield takeLatest(FETCH_NEXT_BOOKING_REQUEST, fetchNextBooking);
}



// WEBPACK FOOTER //
// ./src/store/bookings/sagas.js